export default __webpack_public_path__ + "static/media/NickCarr_Resume.578ea4b9.pdf";